import React, { useMemo } from "react";
import { Buffer } from "buffer";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-solflare";
import { LedgerWalletAdapter } from "@solana/wallet-adapter-ledger";
import { IS_PRERENDER } from "./utils/prerender";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!window.Buffer) {
  window.Buffer = Buffer;
}

const shouldLoadWebFonts =
  !IS_PRERENDER && process.env.REACT_APP_ENABLE_WEB_FONTS !== "false";

const gtmId = process.env.REACT_APP_GTM_ID || "GTM-KH7SHCD5";
const shouldLoadGtm =
  !IS_PRERENDER &&
  process.env.REACT_APP_ENABLE_GTM !== "false" &&
  Boolean(gtmId);

if (shouldLoadWebFonts) {
  const existing = document.querySelector('link[data-coinporate-fonts="true"]');
  if (!existing) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500&family=Inter:wght@300;400;500;600;700&family=Manrope:wght@700&family=Poppins:wght@300;400;500;600;700&family=Roboto+Mono:wght@300;400;500;600;700&display=swap";
    link.setAttribute("data-coinporate-fonts", "true");
    document.head.appendChild(link);
  }
}

if (shouldLoadGtm) {
  const existingGtm = document.querySelector(
    'script[data-coinporate-gtm="true"]'
  );
  if (!existingGtm) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.setAttribute("data-coinporate-gtm", "true");
    document.head.appendChild(script);
  }
}

if (!IS_PRERENDER) {
  import("@solana/wallet-adapter-react-ui/styles.css");
}

function Root() {
  const endpoint = "https://solana-rpc.publicnode.com";
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      new LedgerWalletAdapter(),
    ],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <App />
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
